import { Injectable } from '@angular/core';
import { firestore } from 'firebase';

@Injectable({
  providedIn: 'root'
})
export class FirestoreTimestampTimeAdapterService {

  constructor() { }

  getTimestamp(timestamp: firestore.Timestamp, time: string) {
    if (timestamp && time) {
      const pieces = time.split(":");
      const h = pieces[0];
      const m = pieces[1];
      const date = timestamp.toDate();
      date.setHours(parseInt(h));
      date.setMinutes(parseInt(m));
      return firestore.Timestamp.fromDate(date);
    }
  }
}
